import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/AuthContext';
import { useQuestionnaire } from '../../lib/QuestionnaireContext';
import { Button } from '../ui/Button';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '../ui/Card';

interface QuestionnaireStarterProps {
  onCancel?: () => void;
}

const QuestionnaireStarter: React.FC<QuestionnaireStarterProps> = ({ onCancel }) => {
  const { currentUser } = useAuth();
  const { createQuestionnaire, dashboardSettings, loadDashboardSettings } = useQuestionnaire();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);

  // Load dashboard settings when component mounts
  useEffect(() => {
    loadDashboardSettings();
  }, [loadDashboardSettings]);

  const handleStartQuestionnaire = async () => {
    try {
      setCreating(true);
      const questionnaireId = await createQuestionnaire();
      
      // Navigate without adding projectType parameter to prevent loops
      // The projectType is already set to 'website' in createQuestionnaire
      setTimeout(() => {
        navigate(`/questionnaire/form/${questionnaireId}`);
      }, 500);
    } catch (error) {
      console.error('Error creating questionnaire:', error);
      setCreating(false);
    }
  };

  return (
    <div className="flex-1 bg-background">
      <div className="container max-w-5xl mx-auto p-4">
        <Card className="mb-8">
          <CardHeader>
            <CardTitle>
              {dashboardSettings?.welcomeTitle || 'Welcome to the Questionnaire'}
            </CardTitle>
            <CardDescription>
              {dashboardSettings?.welcomeDescription || 
               'Please fill out the questionnaire to the best of your knowledge. We\'ve broken it down into smaller sections to make it easier to complete. We will use your responses to inform the scope of our proposal. Please note that any major deviations (additional pages, functionalities, or integrations) that are not mentioned could result in an additional estimate.'}
            </CardDescription>
          </CardHeader>
          <CardFooter className="flex justify-between">
            {onCancel && (
              <Button 
                variant="outline" 
                onClick={onCancel}
              >
                Cancel
              </Button>
            )}
            <div className={onCancel ? '' : 'ml-auto'}>
              <Button 
                variant="default" 
                onClick={handleStartQuestionnaire}
                disabled={creating}
              >
                {creating ? 'Creating...' : (dashboardSettings?.startButtonText || 'Start New Questionnaire')}
              </Button>
            </div>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default QuestionnaireStarter; 